import type { DocumentType } from '../lib/types';
import styles from './DocumentTypeSegmented.module.css';

const OPTIONS: { id: DocumentType; label: string }[] = [
  { id: 'auto', label: 'Auto-detect' },
  { id: 'earnings-call', label: 'Earnings Call' },
  { id: '10-k-mdna', label: '10-K MD&A' },
  { id: 'credit-report', label: 'Credit Report' },
  { id: 'press-release', label: 'Press Release' },
  { id: 'other', label: 'Other' },
];

interface Props {
  value: DocumentType;
  onChange: (value: DocumentType) => void;
  className?: string;
}

export function DocumentTypeSegmented({ value, onChange, className }: Props) {
  return (
    <div role="radiogroup" aria-label="Document type" className={[styles.group, className].filter(Boolean).join(' ')}>
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          type="button"
          role="radio"
          aria-checked={value === o.id}
          className={[styles.option, value === o.id ? styles.active : ''].join(' ')}
          onClick={() => onChange(o.id)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
